var controller = new ScrollMagic.Controller();

if (document.getElementById('peas-group')) {
  var peasGroup = new TimelineMax({
    repeat: 0,
  }).to("#pea-1", .85, {
    transformOrigin: "center",
    rotate: -360,
    transform: 'translateX(0)',
    repeat: 0
  }, 'peaEnter+=.2').to("#pea-2", 1, {
    transformOrigin: "center",
    rotate: -360,
    transform: 'translateX(0)',
    repeat: 0
  }, 'peaEnter');
  var peasGroupScene = new ScrollMagic.Scene({
      triggerElement: '#peas-group',
      offset: -300 // start scene after scrolling for 100px
      // duration: 300 // pin the element for 400px of scrolling

    })
    .setTween(peasGroup)
    .addTo(controller);
}

if(document.getElementById('donate-cta')) {
  var fruitGroup = new TimelineMax({
      repeat: 0,
    })
    .from("#banana", 1, {
      transformOrigin: "center",
      rotate: 10,
      transform: 'translateY(-100px)',
      repeat: 0
    }, 'fruit-group')
    .from("#bean", 1, {
      transformOrigin: "center",
      rotate: -10,
      transform: 'translateY(-150px)',
      repeat: 0
    }, 'fruit-group')
    .from("#pea", 1.9, {
      transformOrigin: "center",
      rotate: 320,
      transform: 'translateY(-300px)',
      repeat: 0,
      ease: Bounce.easeOut
    }, 'fruit-group+=.25');

  var fruitGroup = new ScrollMagic.Scene({
      triggerElement: '#donate-cta',
      offset: -500, // start scene after scrolling for 100px
      // duration: 700 // pin the element for 400px of scrolling

    })
    .setTween(fruitGroup)
    .addTo(controller);
}

if (document.getElementById('cucumber-slice')) {
  var cucumberTrigger = $('#cucumber-slice').parent();
  var cucumber = new TimelineMax({
    repeat: 0,
  }).from(cucumberTrigger, 2, {
    transformOrigin: "150% 150%",
    rotate: 50,
    transform: 'translateX(-5px)',
    repeat: 0
  });

  var cucumber = new ScrollMagic.Scene({
    triggerElement: cucumberTrigger,
    offset: -200, // start scene after scrolling for 100px
  }).setTween(cucumber).addTo(controller);
}

if (document.getElementById('egg')) {
  var eggTrigger = $('#egg').parent();
  var egg = new TimelineMax({
    repeat: 0,
  }).from("#egg-yolk", 2, {
    transformOrigin: "150% 150%",
    x: 100,
    y: -50,
    repeat: 0,
    ease: "elastic.out(1, 0.3)",
  });
  var egg = new ScrollMagic.Scene({
    triggerElement: "#egg",
    offset: -200, // start scene after scrolling for 100px
    // duration: 400 // pin the element for 400px of scrolling

  })
  .setTween(egg)
  .addTo(controller);
}

if (document.getElementById('soup')) {
  
  new Vivus('soup', {
    type: 'delayed',
    duration: 100,
    animTimingFunction: Vivus.EASE
  });
}

if (document.getElementById('spinach-bunch')) {
  var spinachBunchTrigger = $('#spinach-bunch').parent();
  var spinachBunch = new TimelineMax({
    repeat: 0,
  }).from('.rotateSpinach-op', 2, {
    rotate: 5,
    transformOrigin: "bottom",
    ease: "elastic.out(1, 0.3)",
  }, 'peek').from('.rotateSpinach', 2, {
    rotate: -2,
    transformOrigin: "bottom",
    ease: "elastic.out(1, 0.3)",
  }, 'peek');
  var spinachBunch = new ScrollMagic.Scene({
      triggerElement: "#spinach-bunch",
    })
    .setTween(spinachBunch)
    .addTo(controller);
}